<template>
  <div id="smartsearch-serp__results" :class="classList">
    <ComponentLoader :loading="loading"/>
    <PaginationContainer v-if="useTop" :position="'top'"/>
    <ButtonsContainer/>
    <MarkedFiltersContainer v-if="useMarkedFilters && hasSelectedFilters && !showAsideFilters"/>
    <TagList v-if="showTagList"/>
    <ListingContainer/>
    <PaginationContainer v-if="useBottom"/>
  </div>
</template>

<script setup lang="ts">

import ButtonsContainer from './ButtonsContainer/ButtonsContainer.vue'
import ListingContainer from './ListingContainer/ListingContainer.vue'
import PaginationContainer from './PaginationContainer/PaginationContainer.vue'
import MarkedFiltersContainer from '@/components/SerpPage/FiltersContainer/MarkedFilters/MarkedFiltersContainer.vue'
import ComponentLoader from '@/components/ComponentLoader.vue'
import TagList from '@/components/SerpPage/TagList.vue'

import {toRefs, inject, computed} from "vue";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";

import {SmartSearchConfigInterface} from '@/core/types'
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";

const {hasSelectedFilters} = storeToRefs(useFiltersStore())
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const useMarkedFilters = SmartSearchConfig.value.serp.markedFilters.enabled
const {useTop, useBottom} = SmartSearchConfig.value.serp.pagination
const {showAsideFilters} = toRefs(SmartSearchConfig.value.serp.filters)
const {showTagList} = toRefs(SmartSearchConfig.value.serp.tagList)


const serpStore = useSerpResultsStore();
const mobileViewStore = useMobileViewStore();

const {loading, noResultsState} = storeToRefs(serpStore)
const filtersStore = useFiltersStore();
const {getFiltersLength} = storeToRefs(filtersStore)
const {isMobileView, isTabletView} = storeToRefs(mobileViewStore)
const classList = computed(() => `smartsearch-serp__results qon-test-class q-position-relative ${isMobileView.value ? 'q-w-100' : ''} ${!noResultsState.value && showAsideFilters.value && getFiltersLength.value ? `${isTabletView.value ? 'q-col-12' : 'q-col-md-8 q-col-lg-9' }` : 'q-col-md-12'}  `)

</script>

<style>
#smartsearch-serp__results {
  min-height: 50vh;
}

.smartsearch-serp__input-container::before {
  content: "";
  display: block;
  position: absolute;
  background-color: rgb(149, 150, 153);
  -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPnNlYXJjaDwvdGl0bGU+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBzdHlsZT0iZmlsbDojZmZmO29wYWNpdHk6MCIvPjxwYXRoIGQ9Ik0yMS44MSwyMC42NmwtNC41Mi00LjUxYTguNjMsOC42MywwLDEsMC0xLjA2LDEuMDZsNC41MSw0LjUxWk0zLjczLDEwLjczYTcsNywwLDEsMSw3LDdBNyw3LDAsMCwxLDMuNzMsMTAuNzNaIi8+PC9zdmc+");
  -webkit-mask-size: 20px 20px;
  -webkit-mask-repeat: no-repeat;
  width: 20px;
  height: 20px;
  top: 50%;
  left: 15px;
  transform: translate(0px, -50%);
  z-index: 1040;
}
</style>